var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCreateTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 14.875H7C6.52167 14.875 6.125 14.4783 6.125 14C6.125 13.5217 6.52167 13.125 7 13.125H21C21.4783 13.125 21.875 13.5217 21.875 14C21.875 14.4783 21.4783 14.875 21 14.875Z",
    fill: "#525252"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21.875C13.5217 21.875 13.125 21.4783 13.125 21V7C13.125 6.52167 13.5217 6.125 14 6.125C14.4783 6.125 14.875 6.52167 14.875 7V21C14.875 21.4783 14.4783 21.875 14 21.875Z",
    fill: "#525252"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateTeam);
export default __webpack_public_path__ + "static/media/create-team.8c823d7855f751a6176e4432dfcccd85.svg";
export { ForwardRef as ReactComponent };